import FieldError from "./FieldError";

type TextFieldProps = {
  disabled?: boolean;
  error?: string;
  label: string;
  onBlur?: () => void;
  onChange: (value: string) => void;
  placeholder?: string;
  required?: boolean;
  type?: string;
  value: string;
};

export default function TextField({
  disabled = false,
  error,
  label,
  onBlur,
  onChange,
  placeholder,
  required = false,
  type = "text",
  value,
}: TextFieldProps) {
  return (
    <label className="block">
      <span className="field-label">{label}</span>
      <input
        className="field-input"
        disabled={disabled}
        onBlur={onBlur}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        required={required}
        type={type}
        value={value}
      />
      <FieldError error={error} />
    </label>
  );
}
